import NotifOrder from "./routes/NotifOrder/NotifOrder.vue";
import Payment from "./routes/Payment/Payment.vue";
import GeneralSetting from "./routes/GeneralSetting/GeneralSetting.vue";
import BadgePromo from "./routes/BadgePromo/BadgePromo.vue";

const settingsRoutes = [
  {
    path: "badge-promo",
    name: "Badge-Promo",
    component: BadgePromo,
  },
  {
    path: "general-setting",
    name: "General-Setting",
    component: GeneralSetting,
  },
  {
    path: "notif-order",
    name: "Notif-Order",
    component: NotifOrder,
  },
  {
    path: "payment",
    name: "Payment",
    component: Payment,
  },
];

export default settingsRoutes;
